function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1908(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32.19,
    height: 11.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.095,
    y: 5.87
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11.74,
    width: 32.19,
    height: 34.82,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.364999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.095,
    y: 29.15
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 46.56,
    width: 32.19,
    height: 39.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.02375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.095,
    y: 66.39500000000001
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.23,
    width: 32.19,
    height: 49.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.438
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.095,
    y: 111.18
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 136.12,
    width: 32.19,
    height: 65.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.364999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.095,
    y: 169.10500000000002
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 202.09,
    width: 32.19,
    height: 66.47,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.438
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.095,
    y: 235.325
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 268.56,
    width: 32.19,
    height: 67.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.438
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.095,
    y: 302.255
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 335.94,
    width: 32.19,
    height: 69.48,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.438
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.095,
    y: 370.68
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 405.42,
    width: 32.19,
    height: 69.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.576666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.095,
    y: 440.27500000000003
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 475.13,
    width: 32.19,
    height: 72.83,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.598571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.095,
    y: 511.545
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 547.96,
    width: 32.19,
    height: 75.95,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.02375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.095,
    y: 585.9350000000001
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 623.92,
    width: 32.19,
    height: 76.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.364999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.095,
    y: 661.9599999999999
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 0,
    width: 48.47,
    height: 51.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.078333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.425,
    y: 25.645
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.67,
    y: 0,
    width: 49.66,
    height: 51.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.094285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.5,
    y: 25.645
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.33,
    y: 0,
    width: 51,
    height: 51.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.83,
    y: 25.645
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.33,
    y: 0,
    width: 53.8,
    height: 51.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.41125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 208.23000000000002,
    y: 25.645
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.14,
    y: 0,
    width: 53.83,
    height: 51.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.41125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 262.055,
    y: 25.645
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.97,
    y: 0,
    width: 54.27,
    height: 51.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.327142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 316.105,
    y: 25.645
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.24,
    y: 0,
    width: 54.55,
    height: 51.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.41125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.515,
    y: 25.645
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 0,
    width: 55.64,
    height: 51.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.129
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.61,
    y: 25.645
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.43,
    y: 0,
    width: 57.47,
    height: 51.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.327142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 482.165,
    y: 25.645
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.9,
    y: 0,
    width: 60.31,
    height: 51.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.41125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.055,
    y: 25.645
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 571.21,
    y: 0,
    width: 64.01,
    height: 51.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.327142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.215,
    y: 25.645
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 635.22,
    y: 0,
    width: 64.78,
    height: 51.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.41125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.61,
    y: 25.645
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 51.29,
    width: 59.93,
    height: 56.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.155,
    y: 79.59
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 107.89,
    width: 59.93,
    height: 57.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.24125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.155,
    y: 136.855
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 165.82,
    width: 59.93,
    height: 60.32,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.993
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.155,
    y: 195.98
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 226.14,
    width: 59.93,
    height: 61.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.49125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.155,
    y: 256.71999999999997
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 287.29,
    width: 59.93,
    height: 63.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.986
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.155,
    y: 319.17
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 351.05,
    width: 59.93,
    height: 66.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.993
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.155,
    y: 384.18
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 417.31,
    width: 59.93,
    height: 69.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.561428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.155,
    y: 452.12
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 486.94,
    width: 59.93,
    height: 69.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.988333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.155,
    y: 521.815
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 556.69,
    width: 59.93,
    height: 70.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.561428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.155,
    y: 591.72
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 626.75,
    width: 59.93,
    height: 73.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.49125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.155,
    y: 663.375
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.13,
    y: 51.29,
    width: 60.12,
    height: 75.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.515
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.19,
    y: 88.81
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.24,
    y: 51.29,
    width: 61.87,
    height: 75.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.311666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.175,
    y: 88.81
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.12,
    y: 51.29,
    width: 63.67,
    height: 75.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.95875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.955,
    y: 88.81
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.79,
    y: 51.29,
    width: 65.24,
    height: 75.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.930909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.41,
    y: 88.81
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.03,
    y: 51.29,
    width: 66.25,
    height: 75.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.041666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.155,
    y: 88.81
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.29,
    y: 51.29,
    width: 70.66,
    height: 75.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.094285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 444.62,
    y: 88.81
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.95,
    y: 51.29,
    width: 71.52,
    height: 75.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 515.71,
    y: 88.81
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.46,
    y: 51.29,
    width: 73.36,
    height: 75.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.226666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.14,
    y: 88.81
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.83,
    y: 51.29,
    width: 75.17,
    height: 75.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.821818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.4150000000001,
    y: 88.81
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.13,
    y: 126.33,
    width: 76.84,
    height: 76.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.806666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.55,
    y: 164.75
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.13,
    y: 203.17,
    width: 76.84,
    height: 77.12,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.537777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.55,
    y: 241.73
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.13,
    y: 280.29,
    width: 76.84,
    height: 79.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.977142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.55,
    y: 319.91
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.13,
    y: 359.53,
    width: 76.84,
    height: 80.87,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.55,
    y: 399.965
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.13,
    y: 440.4,
    width: 76.84,
    height: 81.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.403333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.55,
    y: 480.97499999999997
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.13,
    y: 521.55,
    width: 76.84,
    height: 85.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.977142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.55,
    y: 564.0949999999999
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.13,
    y: 606.64,
    width: 76.84,
    height: 93.36,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.684
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.55,
    y: 653.3199999999999
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.96,
    y: 126.33,
    width: 74.44,
    height: 101.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.406666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.18,
    y: 177.105
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.4,
    y: 126.33,
    width: 92.22,
    height: 101.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 289.51,
    y: 177.105
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.62,
    y: 126.33,
    width: 104.37,
    height: 101.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.805,
    y: 177.105
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.99,
    y: 126.33,
    width: 129.61,
    height: 101.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 504.795,
    y: 177.105
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.6,
    y: 126.33,
    width: 130.4,
    height: 101.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.8000000000001,
    y: 177.105
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.96,
    y: 227.88,
    width: 98.46,
    height: 140.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.3075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.19,
    y: 298.28499999999997
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.96,
    y: 368.69,
    width: 98.46,
    height: 153.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.950909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.19,
    y: 445.27
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.96,
    y: 521.85,
    width: 98.46,
    height: 178.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.19,
    y: 610.9250000000001
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.42,
    y: 227.88,
    width: 128.22,
    height: 232.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 331.53000000000003,
    y: 344.115
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395.64,
    y: 227.88,
    width: 304.36,
    height: 232.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 46.494
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.8199999999999,
    y: 344.115
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.42,
    y: 460.35,
    width: 432.58,
    height: 239.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 29.95625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.71000000000004,
    y: 580.1750000000001
  }, "\n        New_York\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1908);
export default __webpack_public_path__ + "static/media/1908.8bc241a06a2044e680a75b33e0a52758.svg";
export { ForwardRef as ReactComponent };